var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "gps-map" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-2" },
          [
            _c("map-filter", {
              attrs: { markers: _vm.markers },
              on: {
                "filter-changed": (markers) => (_vm.filteredMarkers = markers),
              },
            }),
            _c(
              "div",
              { staticClass: "container is-fluid" },
              [
                _c("b-loading", {
                  attrs: {
                    "is-full-page": false,
                    active: _vm.isFetchingMarkerData,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isFetchingMarkerData = $event
                    },
                  },
                }),
                _c("div", {}, [
                  _vm._v(" " + _vm._s(_vm.$t("global.name")) + ": "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.markerData ? _vm.markerData.name : "")),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.$t("global.stock")) + ": "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.markerData ? _vm.markerData.stockCount : 0)
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            !_vm.isLoading
              ? _c("VueLeafletMap", {
                  attrs: { markers: _vm.filteredMarkers, name: "leaflet" },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }